import moment from "moment";
import React from "react";

export default function Navigation({
  dateObject,
  setDateObject,
  setShowMonths,
  setShowYears,
  setShowDays,
  showMonths,
  showYears,
  hideNav,
  inputRef
}) {
  function onSetShowMoths() {
    setShowMonths(true);
    setShowYears(false);
    setShowDays(false);
  }
  function onSetShowYears() {
    setShowMonths(false);
    setShowYears(true);
    setShowDays(false);
  }
  function onSetShowDays() {
    setShowMonths(false);
    setShowYears(false);
    setShowDays(true);
  }
  function prevMonth() {
    setDateObject(moment(dateObject).subtract(1, "month"));
    if (inputRef && inputRef.current) inputRef.current.focus();
  }
  function nextMonth() {
    setDateObject(moment(dateObject).add(1, "month"));
    if (inputRef && inputRef.current) inputRef.current.focus();
  }
  return (
    <nav>
      <button aria-label="go to previous Month" className="fn-btn" onClick={() => prevMonth()} type="button">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill="currentColor" />
          <script xmlns="" />
        </svg>
      </button>
      {hideNav
        ? (
          ""
        )
        : (
          <>
            <button
              onClick={() => {
                if (showMonths) {
                  onSetShowDays();
                } else {
                  onSetShowMoths();
                }
              }}
              type="button"
              className="fn-btn"
            >
              {dateObject.format("MMMM")}
            </button>
            <button
              onClick={() => {
                if (showYears) {
                  onSetShowDays();
                } else {
                  onSetShowYears();
                }
              }}
              type="button"
              className="fn-btn"
            >
              {dateObject.format("YYYY")}
            </button>
          </>
        )}
      <button aria-label="go to next Month" className="fn-btn" type="button" onClick={e => nextMonth()}>
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" fill="currentColor" />
          <script xmlns="" />
        </svg>
      </button>
    </nav>
  );
}
